import React from 'react';
import { PlayerExternalAPI } from '../../api/external/PlayerExternalAPI';

export const PlayerExternalAPIContext = React.createContext<
  PlayerExternalAPI | undefined
>(undefined);
